import { ITodo } from './types';

export const initialTodos: ITodo[] = [
  { id: 12, task: 'React', completed: false },
  { id: 13, task: 'Angular', completed: true }
];
